import type React from 'react';
import { createContext, useContext } from 'react';
import type { CallBackProps } from 'react-joyride';

import { useOnboarding } from './use-onboarding';

interface OnboardingContextType {
  startTour: () => void;
  replayTour: () => void;
  stopTour: () => void;
  resumeOnboardingTour: (fromStep?: number) => void;
  isRunning: boolean;
  stepIndex: number;
  persistedStepIndex: number;
  handleJoyrideCallback: (data: CallBackProps) => void;
  showPermissionsDock: boolean;
  handlePermissionsDockClose: () => void;
  triggerPermissionsDock: () => void;
  showSurvey: boolean;
  surveyInstanceId: number;
  handleSurveyComplete: () => void;
  handleSurveyClose: () => void;
}

const OnboardingContext = createContext<OnboardingContextType | null>(null);

export const OnboardingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const onboardingState = useOnboarding();

  return (
    <OnboardingContext value={onboardingState}>
      {children}
    </OnboardingContext>
  );
};

export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error(
      'useOnboardingContext must be used within OnboardingProvider'
    );
  }
  return context;
};
